import xhr from './../../utils/xhr';

const api = {
    get: (filters = { pestle: null, entityId: null, payload: null }, sorting = {
        sortBy: "createdDate",
        direction: "DESC"
    }, pagination = {pageSize: -1, pageNumber: -1}) => {
        return xhr.post({
            url: `/api/articles/riskEntity/${filters.entityId}/${filters.pestle}?pageNumber=${pagination.pageNumber}&pageSize=${pagination.pageSize}&sortBy=${sorting.sortBy}&direction=${sorting.direction}`,
            data: { companyId: filters.entityId, ...filters.payload }
        });
    },

    count: (filters = {pestle: null, entityId: null,  payload: null}) => {
        return xhr.post({
            url: `/api/articles/count/riskEntity/${filters.entityId}/${filters.pestle}`,
            data: { companyId: filters.entityId, ...filters.payload }
        });
    }
}

export default api;



// WEBPACK FOOTER //
// ./src/scripts/pages/TrendingEntities/TrendingEntities.api.js